<template>
  <el-dialog
    :title="$t('menu.delete-user')"
    :visible.sync="dialogVisible"
    width="320px"
    :center="true"
    :show-close="false"
    class="sign-out-dialog"
  >
    <el-form
      :model="deleteUserForm"
      :rules="getFormRules"
      ref="deleteUserForm"
      class="change-password-form"
      label-position="top"
    >
      <el-form-item
        label="User ID"
        prop="sub"
      >
        <el-input v-model="deleteUserForm.sub" />
      </el-form-item>
      <el-form-item class="mt-20">
        <el-button
          type="primary"
          class="primary-button"
          @click="handleDeleteClick"
        >
          {{ $t('form.delete') }}
        </el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>

import { usersAPI } from '../../shared/services/users.service'

export default {
  name: 'DeleteUserDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    deleteUserForm: {
      sub: ''
    }
  }),
  computed: {
    getFormRules: function () {
      return {
        sub: [
          {
            required: true,
            message: this.$t('form.validation.required', { field: this.$t('profile.phone') }),
            trigger: 'blur'
          }
        ]
      };
    },
    dialogVisible: {
      get: function () {
        return this.visible;
      },
      set: function (value) {
        this.$emit('update:visible', value);
      }
    }
  },
  methods: {
    async handleDeleteClick () {
      this.$refs['deleteUserForm'].validate(async (valid) => {
        if(valid) {
          const [ error ] = await usersAPI.deleteUser(this.deleteUserForm.sub)

          if(error) {
            this.$message.error('User not deleted');
          } else {
            this.dialogVisible = false;
            this.$message.success(this.$t('auth.user-deleted'));
            this.deleteUserForm.sub = '';
          }
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
